import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { HTMLTable } from "@blueprintjs/core";
import { SpedApuracaoStore } from "../../stores/sped/SpedApuracaoStore";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IconButton } from "@mui/material";
import { newIReceita } from "../../model";
import moment from "moment";
import { get15thDayOfNextMonth } from "../../utils";
import { DaeAvulsoStore } from "../../stores/dae-avulso/DaeAvulsoStore";

const numeral = require("numeral");

interface Props {
  item: any
}

@observer
export default class ApuracaoEntradaTable extends React.Component<Props, {}> {

  obs = observable({
    apuracao: [] as any,
    impostos: [] as any,
    imposto_selecionado: "" as string,
  })

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {

    this.obs.impostos = this.props.item

  }

  onTreeStateChange = (state) => { }

  /**
 * Retorna uma sequência de espaços em branco HTML para ser usada como margem ou espaçamento visual no layout.
 * 
 * Esta função é útil quando você precisa de um espaçamento fixo no layout, representado por uma sequência de entidades HTML `&nbsp;` (não quebráveis), que são usadas para gerar espaços no conteúdo renderizado.
 * 
 * @returns {JSX.Element} Um elemento JSX contendo uma série de espaços não quebráveis (`&nbsp;`), que pode ser utilizado para criar uma margem visual ou espaçamento entre elementos.
 */
  marginItem() {
    return (<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>)
  }

  /**
 * Retorna uma sequência de espaços em branco HTML para ser usada como margem ou espaçamento visual no layout.
 * 
 * Esta função é útil quando você precisa de um espaçamento fixo no layout, representado por uma sequência de entidades HTML `&nbsp;` (não quebráveis), que são usadas para gerar espaços no conteúdo renderizado.
 * 
 * @returns {JSX.Element} Um elemento JSX contendo uma série de espaços não quebráveis (`&nbsp;`), que pode ser utilizado para criar uma margem visual ou espaçamento entre elementos.
 */
  marginSubitem() {
    return (<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>)
  }

  /**
 * Retorna uma linha vazia em formato de tabela, com células preparadas para espaçamento visual.
 * 
 * A função gera uma linha de tabela (`<tr>`) contendo quatro células (`<td>`), sendo a primeira célula preenchida com o caractere de espaço invisível Unicode (`\u200B`) e as outras três células vazias. 
 * Esta linha pode ser utilizada para criar espaçamentos ou margens dentro de uma tabela, sem exibir dados visíveis.
 * 
 * @returns {JSX.Element} Um elemento JSX representando uma linha de tabela vazia, com células vazias ou com conteúdo invisível.
 */
  rowEmpty() {

    return (<tr>
      <td>{"\u200B"}</td>
      <td></td>
      <td></td>
      <td></td>
    </tr>)

  }

  /**
 * Função chamada quando um nome é clicado, que realiza o processamento de dados relacionados ao ICMS, FCP, ou outros débitos e créditos.
 * 
 * A função executa os seguintes passos:
 * 1. Limpa o estado de `apuracao` e `imposto_selecionado` no objeto `this.obs`.
 * 2. Define o imposto selecionado com base no nome do nó (`nodeData.name`).
 * 3. Calcula o valor de ICMS (ou outro imposto relacionado) dependendo do campo do `nodeData` (ICMS, FCP ou 1139).
 * 4. Calcula o saldo total considerando os valores de débito e crédito.
 * 5. Preenche uma tabela com várias linhas, incluindo os totais de débito, crédito, e o saldo final.
 * 6. Adiciona valores e informações adicionais a partir do `nodeData.outros_debitos`, se existirem.
 * 7. Atualiza o estado `apuracao` com as linhas geradas para visualização.
 * 
 * A tabela gerada contém informações sobre:
 * - Total de produtos/receita.
 * - Total de débitos (com base em ICMS ou outros impostos).
 * - Total de créditos.
 * - Valor contestado.
 * - O saldo de ICMS a recolher ou o saldo credor de ICMS para o mês seguinte, dependendo do cálculo final.
 * 
 * @param {Object} nodeData Dados relacionados ao imposto, incluindo valores de ICMS, FCP, valores contestados e outros débitos.
 * 
 * @returns {void} Não retorna valor. A função altera o estado da aplicação atualizando a variável `apuracao` com os dados processados.
 */
  onNameClick = (nodeData) => {

    this.obs.apuracao = []
    this.obs.imposto_selecionado = ""

    this.obs.imposto_selecionado = nodeData.name

    const rows = []

    let icms = 0

    if (nodeData.campo == "ICMS") { icms = (nodeData.valor_icms || 0) }
    if (nodeData.campo == "FCP") { icms = (nodeData.valor_fcp || 0) }
    if (nodeData.campo == "1139") { icms = (nodeData.valor_1139 || 0) }

    let saldo_total = icms - (nodeData.valor_contestacao_icms || 0)

    rows.push(<tr>
      <td>Total produtos / receita</td>
      <td></td>
      <td></td>
      <td className="valor-table-apuracao">{numeral(nodeData.valor || 0).format("0,0.00")}</td>
    </tr>)

    rows.push(this.rowEmpty())

    rows.push(<tr>
      <td>Total de débitos</td>
      <td></td>
      <td></td>
      <td className="valor-table-apuracao">{numeral(icms || 0).format("0,0.00")}</td>
    </tr>)

    nodeData?.outros_debitos?.forEach(value => {

      rows.push(<tr>
        <td>{this.marginSubitem()}{value.nome}</td>
        <td className="valor-table-apuracao">{numeral(value.valor || 0).format("0,0.00")}</td>
        <td></td>
        <td></td>
      </tr>)

    })

    rows.push(this.rowEmpty())

    rows.push(<tr>
      <td>Total de créditos</td>
      <td></td>
      <td></td>
      <td className="valor-table-apuracao">{numeral(nodeData.valor_contestacao_icms || 0).format("0,0.00")}</td>
    </tr>)

    rows.push(<tr>
      <td>{this.marginItem()}Valor Contestado</td>
      <td></td>
      <td></td>
      <td className="valor-table-apuracao">{numeral(nodeData.valor_contestacao_icms || 0).format("0,0.00")}</td>
    </tr>)

    rows.push(this.rowEmpty())
    rows.push(this.rowEmpty())

    rows.push(<tr>
      <td><b>{saldo_total > 0 ? "ICMS a recolher" : "Saldo credor de ICMS para o mês seguinte"}</b></td>
      <td></td>
      <td></td>
      <td className="valor-table-apuracao"><b>{numeral(saldo_total || 0).format("0,0.00")}</b></td>
    </tr>)

    this.obs.apuracao = rows

  }

  /**
 * Prepara e configura os dados necessários para gerar um DAE (Documento de Arrecadação de Receitas) avulso.
 * 
 * A função realiza as seguintes ações:
 * 1. Cria uma nova receita, inicializando o objeto `DaeAvulsoStore.obs.receita` com valores padrão.
 * 2. Define a data de vencimento como o 15º dia do próximo mês, calculado com base no período de apuração atual.
 * 3. Define a data de cálculo como a data atual.
 * 4. Atribui o código de receita e o valor a ser pago com base no parâmetro `value` e o saldo total calculado.
 * 5. Define a data de referência do DAE com base no mês e ano do período de apuração.
 * 6. Atribui o CNPJ da empresa selecionada no `SpedApuracaoStore` à receita.
 * 7. Abre o formulário do DAE avulso para visualização ou preenchimento.
 * 
 * @param {Object} value O objeto contendo as informações do código de receita.
 * @param {number} saldo_total O valor total a ser pago, que será atribuído ao DAE.
 * 
 * @returns {void} Não retorna valor. A função apenas altera o estado de `DaeAvulsoStore` e configura os dados do DAE.
 */
  handleDae(value, saldo_total: number) {

    DaeAvulsoStore.obs.receita = newIReceita()

    DaeAvulsoStore.obs.date_vencimento = get15thDayOfNextMonth(moment(SpedApuracaoStore.obs.periodoEntrada[0]).toDate())
    DaeAvulsoStore.obs.date_calculo = new Date()

    DaeAvulsoStore.obs.receita.codigo_receita = value.codigo_receita;
    DaeAvulsoStore.obs.receita.valor_pagar = Math.abs(saldo_total || 0);

    DaeAvulsoStore.obs.receita.data_referencia = moment(SpedApuracaoStore.obs.periodoEntrada[0]).format("MM/YYYY");

    DaeAvulsoStore.obs.receita.cnpj = SpedApuracaoStore.obs.selectedEmpresaEntrada.cnpj

    DaeAvulsoStore.obs.open_dae_avulso = true

  }

  /**
 * Verifica se o DAE (Documento de Arrecadação de Receitas) pode ser gerado com base nos valores do imposto, e retorna um botão de ação para gerar o DAE, se aplicável.
 * 
 * A função realiza os seguintes passos:
 * 1. Calcula o saldo total, considerando o valor do imposto (ICMS, FCP ou 1139) e o valor contestado.
 * 2. Se o saldo total for positivo e o valor de DAE avulso for verdadeiro, exibe um botão de ícone que, quando clicado, chama a função `handleDae` para gerar o DAE.
 * 3. Se o saldo total não for positivo ou o valor de DAE avulso for falso, exibe um botão desabilitado.
 * 
 * @param {Object} value O objeto contendo os valores e informações sobre o imposto (ICMS, FCP, ou 1139), valores contestados e se o DAE avulso pode ser gerado.
 * 
 * @returns {JSX.Element} Um componente JSX que renderiza um botão de ícone, que aciona a função de geração do DAE se as condições forem atendidas. Caso contrário, exibe um botão desabilitado.
 */
  valid_dae(value) {

    let saldo_total = 0

    if (value.campo == "ICMS") saldo_total = ((value.valor_icms || 0) - (value.valor_contestacao_icms || 0))
    if (value.campo == "FCP") saldo_total = ((value.valor_fcp || 0) - (value.valor_contestacao_icms || 0))
    if (value.campo == "1139") saldo_total = ((value.valor_1139 || 0) - (value.valor_contestacao_icms || 0))

    return (

      <>

        {saldo_total > 0 && value.dae_avulso ?

          <IconButton className="icon-dae">
            <img src="/images/arquivo.png" width={50} onClick={() => this.handleDae(value, saldo_total)} />
          </IconButton>

          :

          <IconButton disabled style={{ pointerEvents: "none" }}>{"\u200B"}</IconButton>

        }

      </>

    )

  }

  render() {

    return (
      <>
        <MDBRow>
          <MDBCol md="4" style={{ overflow: "auto", borderRight: "1px solid rgba(27, 99, 111, 0.15)", maxHeight: 500 }}>
            {this.obs.impostos && this.obs.impostos.length ?
              <>
                <div style={{ fontSize: 14, marginBottom: 10 }}><b>IMPOSTOS</b></div>

                {this.obs.impostos.map(value => {

                  return (

                    <MDBBtn className={this.obs.imposto_selecionado == value.name ? "list-impostos list-impostos-selected" : "list-impostos"} onClick={() => this.onNameClick(value)}>

                      <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                        <span>{value.name}</span>

                        {this.valid_dae(value)}

                      </div>

                    </MDBBtn>)

                })}

              </>

              :

              <div style={{ fontSize: 14, marginBottom: 10 }}>
                <b>Nenhum imposto encontrado!</b>
              </div>
            }

          </MDBCol>

          <MDBCol md="8">

            {Object.keys(this.obs.apuracao).length ?

              <>
                <div style={{ fontSize: 14, textAlign: "center", marginBottom: 10 }}>
                  <b>IMPOSTO: {this.obs.imposto_selecionado}</b>
                </div>

                <HTMLTable className="table-hover " style={{ width: "100%" }} small striped>
                  <thead>
                    <tr>
                      <th style={{ borderRight: "1px solid rgba(27, 99, 111, 0.15)", width: "40%", textAlign: "center" }}>Descrição</th>
                      <th style={{ borderRight: "1px solid rgba(27, 99, 111, 0.15)", width: "20%", textAlign: "center" }}>Valor</th>
                      <th style={{ borderRight: "1px solid rgba(27, 99, 111, 0.15)", width: "20%", textAlign: "center" }}>Subtotal</th>
                      <th style={{ width: "20%", textAlign: "center" }}>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.obs.apuracao}
                  </tbody>
                </HTMLTable>

              </>

              : <></>}

          </MDBCol>
        </MDBRow>

      </>
    )
  }
}